import { createContext, useContext } from 'react';

export interface UserInfo {
  id: string;
  email: string;
  role: string;
}

interface UserContextType {
  user: UserInfo;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);

/**
 * Hook to access user context
 */
export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserContext.Provider');
  }
  return context;
};
